import { axios } from "../../utils";

export async function getDevices(accessToken) {
  const response = await axios.get("/devices", {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return response.data;
}
